const defaultFilters = {
  identifier: '',
  title: '',
  specification: '',
  migrationScenario: '',
  lastComment: '',
  lastRcComment: '',
  status: [],
  owner: 'All',
  planOwner: 'All',
  category: [],
  subcategory: [],
  strategy: [],
  phase: [],
  priority: [],
  impact: [],
  globality: [],
  range: [],
  report: [],
  probability: 'All',
  riskGroup: 'All',
  overtime: 'All',
  overcost: 'All',
  canWrite: '',
  enabled: true,
  createdAt: [null, null],
  updatedAt: [null, null],
  closedAt: [null, null],
};

export default defaultFilters;
